import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // Plugin para cargar traducciones desde /public/locales
  .use(Backend)
  // Plugin para detectar idioma del navegador
  .use(LanguageDetector)
  // Conecta con React
  .use(initReactI18next)
  .init({
    // Idioma por defecto
    fallbackLng: 'es',
    
    // Idiomas soportados
    supportedLngs: ['es', 'en'],
    
    // Detección automática basada en:
    // 1. localStorage
    // 2. navigator.language (idioma del navegador)
    // 3. fallback a español
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    
    // Configuración del backend
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    // Namespace por defecto
    ns: ['common', 'landing'],
    defaultNS: 'common',
    
    // Debug en desarrollo
    debug: process.env.NODE_ENV === 'development',
    
    // Interpolación
    interpolation: {
      escapeValue: false, // React ya hace escape
    },
    
    // React-specific
    react: {
      useSuspense: true,
    },
  });

export default i18n;
